import React, { Component } from 'react';
import styled, {keyframes} from 'styled-components';
import media from '../../theme/media';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn, OneHalf, OneThird, KeySection, SideColumnRightSkwiz } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { Caption, HeadingH1, HeadingH2, DropCap, LinkCustom } from '../../theme/typography';
import { VideoIphoneVerticalContainer, VideoIphoneHorizontalContainer, VideoIpadHorizontalContainer } from '../../theme/video';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PageFooter from '../../components/PageFooter/PageFooter';

const small = require('../../assets/Skwiz/top.png');
const medium = require('../../assets/Skwiz/top@2x.png');
const large = require('../../assets/Skwiz/top@3x.png');

const middleSmall = require('../../assets/Skwiz/middle.png');
const middleMedium = require('../../assets/Skwiz/middle@2x.png');
const middleLarge = require('../../assets/Skwiz/middle@3x.png');

const bottomSmall = require('../../assets/Skwiz/bottom.png');
const bottomMedium = require('../../assets/Skwiz/bottom@2x.png');
const bottomLarge = require('../../assets/Skwiz/bottom@3x.png');

const revealSmall = require('../../assets/Skwiz/reveal.png');
const revealMedium = require('../../assets/Skwiz/reveal@2x.png');
const revealLarge = require('../../assets/Skwiz/reveal@3x.png');

const SkwizIlloTop = () => (
  <img src={small} srcSet={`${small} 300w, ${medium} 768w, ${large} 1280w`} alt=""/>
);

const SkwizIlloMiddle = () => (
  <img src={middleSmall} srcSet={`${middleSmall} 300w, ${middleMedium} 768w, ${middleLarge} 1280w`} alt=""/>
);

const SkwizIlloBottom = () => (
  <img src={bottomSmall} srcSet={`${bottomSmall} 300w, ${bottomMedium} 768w, ${bottomLarge} 1280w`} alt=""/>
);

const SkwizIlloReveal = () => (
  <img src={revealSmall} srcSet={`${revealSmall} 300w, ${revealMedium} 768w, ${revealLarge} 1280w`} alt=""/>
);

const SideColumnRightSkwizReveal = styled.div`
  position: absolute;
  width: 124px;
  right: -86px;
  top: calc(50% - 180px);
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export default class SkwizApp extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
  }

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
      
        <Header theme={"skwiz " + this.state.messageShown} color="#485CDC" date="Spring 2019 - Present" role="Concept, Design, Development" action={this.handler} />
          <Article className={"skwiz " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="skwiz">Skwiz</HeadingH2>
                  <HeadingH1>Drawing Game</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
                
                <KeySection className={"none " + this.state.messageShown}>
                    <VideoIpadHorizontalContainer>
                        <img alt="" src={require('../../assets/Skwiz/iPad@2x.png')} width="100%" />
                    </VideoIpadHorizontalContainer>
                </KeySection>
                
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>S</DropCap>kwiz is an upcoming iOS app based on the classic drawing game Exquisite Corpse. Skwiz was created by Michael McCombie, James Dybvig, and Vince Joy. Michael acts as the project manager, game designer, and sole developer for the app. Work began in the Summer of 2019 and with the app currently undergoing Beta testing with members of the art and animation community. More information will be shared soon!</p>
                </MainColumn>
              </FirstSection>
              
              <Section className={this.state.messageShown}>
                <img alt="" src={require('../../assets/Skwiz/drawings@2x.jpg')} width="100%" />
                <Caption>Drawings created by Mozilla's Creative Team</Caption>
              </Section>
              
              
              <Section className={this.state.messageShown}>
                  <MainColumn>
                      <h2>Next Steps</h2>
                      <p>We're getting close to the launch of the app! All of the major features have been finalized, our animation and illustration work has been locked, we're now polishing the app, fixing bugs, and preparing to launch the app within the app store.  The app is available via TestFlight upon request. This page will be updated once the app is available in the App Store.</p>
                  </MainColumn>
                  <SideColumnRightSkwiz>
                      <img alt="" src={require('../../assets/Home/skwiz-character.gif')} />
                  </SideColumnRightSkwiz>
              </Section>
              
               {/*
              <Section className={this.state.messageShown}>
                <OneHalf>
                  <h2>How to Play</h2>
                  <p>There are two way to play Skwiz. You can either draw with people in the same room as you by passing your phone or iPad around or you can draw with friends and strangers online each person using their own device.</p>
                </OneHalf>
                <OneHalf className="right">
                  <VideoIphoneVerticalContainer>
                    <img alt="" src={require('../../assets/Skwiz/how-to-play.gif')} width="100%" />
                  </VideoIphoneVerticalContainer>
                </OneHalf>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Drawing</h2>
                  <p>When it's someones turn to play they see a prompt telling them which part of the image they're supposed to draw. In the middle of the screen there is a white canvas with dashed lines on either the top, bottom, or both depending on which section of the image that person is supposed to draw.</p>
                  <p>To the left of the canvas there are five buttons: pencil, size, eraser, undo, and redo. One of our goals with this app is to keep things simple and fun, we didn't want to include all the different color and brush options that you would find in a professional drawing app like Procreate. Less is more and by giving users fewer options the end result is a more cohesive drawing. We wanted the game to feel as simple as it does when you're playing with a pen and piece of paper.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <VideoIphoneHorizontalContainer>
                  <img alt="" src={require('../../assets/Skwiz/drawing-bottom.gif')} width="100%" />
                  <div className="notch"/>
                </VideoIphoneHorizontalContainer>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <p>Players can reset their turn by shaking the device (like an etch-a-sketch) or clicking the undo button more than 12 times. Before the drawing erases completely a prompt appears asking the player whether they are sure they want to start over.</p>
                  <p>Clicking on the size button causes a sub-menu to slide in from the left which gives the player three different options for the pen size. We found that restricting the number of options we gave people when it came to drawing made it easier for the next player to match the line weight of the previous drawing.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <OneHalf className="reorder">
                  <VideoIphoneVerticalContainer>
                    <img alt="" src={require('../../assets/Skwiz/waiting.gif')} width="100%" />
                  </VideoIphoneVerticalContainer>
                </OneHalf>
                <OneHalf>
                  <h2>Playing Online</h2>
                  <p>Skwiz is a turn-based game, that means you can't play until someone else finishes their turn. To keep people engaged with the app James created a loading animation and a waiting animation.</p>
                  <p>I made sure that the app told the user which part of the drawing is being worked on and whose turn it is. I also created notifications that let a user know when it is their turn or when the final image is ready to be revealed.</p>
                </OneHalf>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Erasing</h2>
                  <p>Skwiz isn't a professional drawing tools, it's designed to be a simple game that doesn't overwhelm casual drawers. We didn't want to replicate the dense UI that's found in professional drawing apps like Procreate and Illustrator. Instead we opted for the least intimidating UI possible.</p>
                  <p>When playing Skwiz you can erase everything and start over from scratch in one of two ways. The first is by shaking your phone/iPad. We included this feature because it is fun, kinetic, and a concept many people are familiar with.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <VideoIphoneHorizontalContainer className="shake">
                  <img alt="" src={require('../../assets/Skwiz/shake-phone.gif')} width="100%" />
                  <div className="notch"/>
                </VideoIphoneHorizontalContainer>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <p>The second way someone can reset their turn is by pressing the "undo" button more than 12 times. After hitting the undo button 11 times the undo button is replaced with an icon depicting a stick of dynamite. Our intention here was twofold, we assumed that if someone is rapidly hitting the undo button in succession their most likely intention is to start over, we also didn't want to overload the phones memory and slow down the game. Every time someone clicks undo an image is created, by restricting the number of times a person can click "undo" we place a cap on the amount of images we need to temporarily store on a users phone improving the games overall performance.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>The Reveal</h2>
                  <p>Aesthetically I wanted to match the feel of playing exquisite corpse with just a pen and a piece of paper as much as possible. Originally the canvas took up the entire screen, we soon found out that when people played together with separate devices that the different sized iPhones and iPads created incompatible drawings. So to solve this I standardized the aspect ratios of each section and the final drawing itself.</p>
                  <p>iOS devices originally had two key aspect ratios, a 16:9 ratio for iPhones and a 4:3 ratio for iPads. That was until the introduction of the iPhone X and the iPad Pro. These devices added additional aspect ratios. So I went with a 3:2 ratio for the canvas because it could fit on every iOS device. On smaller iPhones the canvas is flush with the top, bottom, and right edges of the device leaving room for a toolbar on the left. On larger iPhones the canvas is flush with the top and bottom and centered in the middle leaving room for the toolbar on the left and the action buttons on the right side of the screen. On iPads the canvas is flush with the left, right, and bottom of the screen leaving space for a toolbar above the canvas towards the top of the screen.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <OneThird>
                  <img alt="" src={require('../../assets/Skwiz/reveal1@2x.png')} width="100%" />
                </OneThird>
                <OneThird>
                  <img alt="" src={require('../../assets/Skwiz/reveal2@2x.png')} width="100%" />
                </OneThird>
                <OneThird>
                  <img alt="" src={require('../../assets/Skwiz/reveal3@2x.png')} width="100%" />
                </OneThird>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <p>For the reveal I went with a 9:16 ratio. This ratio allowed for all three sections of the drawing to be placed on top of one another with just the right amount of overlap. Another one of the benefits to this ratio is that the 9:16 ratio matches the aspect ratio of an Instagram story post making it easy for players to share drawings they created in Skwiz on that app. I also created a custom share button which allows people to post directly to their instagram story.</p>
                  <p>Another aspect of the reveal is that when you click on an image you can see who drew which part of the image and click on their name to be taken to their profile to see all the drawings they've ever made on the app.</p>
                </MainColumn>
              </Section>
              
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Next Steps</h2>
                  <p>Skwiz is nearly finished! The app is currently in beta and is available upon request. There are a couple of more features that I'm working on that will hopefully make the app that much more engaging and fun to play. We are hoping to officially launch the app sometime before the end of the year. You can follow our progress and see some of the drawings that are being created on the platform on our <LinkCustom className="skwiz" href="https://www.instagram.com/skwizcorpse/">Instagram</LinkCustom> page. </p>
                </MainColumn>
              </Section>
              */}
              
              
            </Container>
          </Article>
          <PageFooter present={this.state.messageShown} theme="skwiz" left="none" leftLink="none" rightTitle="Skwiz" right="Color Palettes" rightLink="skwiz-colors"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/SkwizDrawingGame/SkwizDrawingGame.js